import React from 'react';
import WhatsAppApp from './components/WhatsAppApp';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: { main: '#075e54' }, // WhatsApp green
    secondary: { main: '#128c7e' },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <WhatsAppApp />
    </ThemeProvider>
  );
}

export default App;